import axios from "axios";

const API_URL = process.env.REACT_APP_API_ENDPOINT
  ? process.env.REACT_APP_API_ENDPOINT.replace(/\/+$/, "") + "/"
  : "";

/** Distinct values for exit_code, index_name, option_type, entry_type + column list. */
export const fetchFilters = async () => {
  const res = await axios.get(`${API_URL}api/exit-items-browser/filters`);
  return typeof res.data === "string" ? JSON.parse(res.data) : res.data;
};

/** Rows matching the current filters, projected in the column order. */
export const fetchRows = async ({
  exit_code = [],
  index_name = [],
  option_type = [],
  entry_type = [],
  is_wrong_exit = null,
  is_loss = null,
  date_from = null,
  date_to = null,
  limit = 500,
} = {}) => {
  const params = new URLSearchParams();
  exit_code.forEach(v => params.append("exit_code", v));
  index_name.forEach(v => params.append("index_name", v));
  option_type.forEach(v => params.append("option_type", v));
  entry_type.forEach(v => params.append("entry_type", v));
  if (is_wrong_exit !== null && is_wrong_exit !== "") params.set("is_wrong_exit", String(is_wrong_exit));
  if (is_loss !== null && is_loss !== "") params.set("is_loss", String(is_loss));
  if (date_from) params.set("date_from", date_from);
  if (date_to)   params.set("date_to",   date_to);
  params.set("limit", limit);
  const res = await axios.get(`${API_URL}api/exit-items-browser/data?${params.toString()}`);
  return typeof res.data === "string" ? JSON.parse(res.data) : res.data;
};
